import React from 'react';
import '../css/error.css';

class ErrorProvider extends React.Component {
  static error = null;

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleGlobalError = this.handleError.bind(this);
    this.handlePromiseRejection = this.handleError.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ hasError: true, error, errorInfo });
  }

  componentDidMount() {
    window.addEventListener('error', this.handleGlobalError);
    window.addEventListener('unhandledrejection', this.handlePromiseRejection);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleGlobalError);
    window.removeEventListener('unhandledrejection', this.handlePromiseRejection);
  }

  handleError(errorOrEvent) {
    // Prevent the default red overlay in development
    if (errorOrEvent && typeof errorOrEvent.preventDefault === 'function') {
      errorOrEvent.preventDefault();
    }

    let error = errorOrEvent;

    if (errorOrEvent && errorOrEvent.reason instanceof Error) {
      error = errorOrEvent.reason;
    } else if (errorOrEvent && errorOrEvent.error instanceof Error) {
      error = errorOrEvent.error;
    } else if (!(errorOrEvent instanceof Error)) {
      error = new Error('An unknown error occurred');
    }

    this.setState({ hasError: true, error });
  }
  
  render() {
    if (this.state.hasError) {
      return (
        <>
          <div className="error-boundary">
            <div className="error-message">
              <h1>Something went wrong. It's not your fault! Probably ours. Probably...</h1>
              <p>Please try to go back to home or refresh the page. If the error keeps happening, please report it to the staff. They will Probably give the developers a call and we will be crying in a corner.</p>
              <div>
                <button className="red-pill" onClick={() => window.location.href = '/'}>Go to Home</button>
                <button className="blue-pill" onClick={() => window.location.reload()}>Refresh Page</button>
              </div>
            </div>

            <br /><br /><br />

            <div className="error-details">
              <h1>Error Details</h1>
              <p><strong>Time:</strong> {new Date().toLocaleString()}</p>
              <p><strong>URL:</strong> {window.location.href}</p>
              <p><strong>Error:</strong> {this.state.error ? this.state.error.message : 'Unknown error'}</p>
              {this.state.error && this.state.error.stack && (
                <pre>
                  {this.state.error.stack}
                </pre>
              )}
            </div>
          </div>
        </>
      );
    }
    return this.props.children;
  }
}

export default ErrorProvider;